/**
 * Matchmaking Enums
 *
 * Enums for the matchmaking system.
 */

// Match Status
export enum EMatchStatus {
  WAITING = 'waiting',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
}

// Lobby Status
export enum ELobbyStatus {
  SEARCHING = 'SEARCHING',
  WAITING_CONFIRMATION = 'WAITING_CONFIRMATION',
  ACTIVE = 'ACTIVE',
  FINISHED = 'FINISHED',
  CANCELLED = 'CANCELLED',
}

// Leagues
export enum ELeague {
  IRON = 'iron',
  BRONZE = 'bronze',
  SILVER = 'silver',
  GOLD = 'gold',
  PLATINUM = 'platinum',
  DIAMOND = 'diamond',
}

export const LEAGUE_ORDER: ReadonlyArray<ELeague> = [
  ELeague.IRON,
  ELeague.BRONZE,
  ELeague.SILVER,
  ELeague.GOLD,
  ELeague.PLATINUM,
  ELeague.DIAMOND,
];

export function getLeagueOrder(league: ELeague): number {
  return LEAGUE_ORDER.indexOf(league);
}
